import React from 'react';

import { paramFromMatch } from 'utils/history';
import SignupNameScreen from './SignupNameScreen';

export default (props: any) => (
  <SignupNameScreen {...props} token={paramFromMatch(props.match, 'token')} />
);
